export default __webpack_public_path__ + "static/netlify-ef4bcec8dd0761b7e1142212bd2deb3e.svg";